<template>
  <div class="appindex flex">
    <div class="appindex-left">
      <p class="fontdark font16 fontbig mt-24 ml-24">服务使用者管理</p>
      <div class="line"></div>
      <div
        class="fontcursor"
        v-for="(item, index) in menuList"
        :key="index"
        :class="
          activeMenu == index + 1
            ? 'appindex-left-menu menuactive'
            : 'appindex-left-menu'
        "
        @click="link(`${item.path}`, index + 1)"
      >
        {{ item.displayName }}
      </div>
      <!-- <div
        :class="
          activeMenu == 1
            ? 'appindex-left-menu menuactive'
            : 'appindex-left-menu'
        "
        @click="link('/serveUse/serveUseList', 1)"
      >
        服务使用者管理
      </div>
      <div
        :class="
          activeMenu == 2
            ? 'appindex-left-menu menuactive'
            : 'appindex-left-menu'
        "
        @click="link('/serveUse/serveUseChecklist', 2)"
      >
        服务使用者审核
      </div> -->
    </div>
    <div class="appindex-right">
      <div class="appindex-right-top">
        <Breadcrumb class="bread">
          <BreadcrumbItem
            v-for="(item, index) in bread"
            v-if="item.meta.title"
            :key="item.path"
          >
            <span v-if="index == bread.length - 1">{{ item.meta.title }}</span>
            <!-- :to="item.redirect || item.path" -->
            <span
              class="linkspan fontcursor"
              v-else
              @click="linkPath(item.redirect.path)"
              >{{ item.meta.title }}</span
            >
          </BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="appindex-right-main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "",
  data() {
    return {
      path: "",
      activeMenu: 1,
      serveAddress: "",
      pathList: [
        "/serveUse/serveUseChecklist",
        "/serveUse/serveUseCheckDetail",
      ],
      showTip: false,
      flagAuth: "", //判断用户是否认证
      menuList: [
        {
          displayName: "服务使用者管理",
          displayType: "MENU",
          frontendCode: "consumer_manage",
          id: 10031,
          parentId: 10030,
          path: "/serveUse/serveUselist",
        },
        {
          displayName: "服务使用者审核",
          displayType: "MENU",
          frontendCode: "consumer_audit",
          id: 10033,
          parentId: 10030,
          path: "/serveUse/serveUseChecklist",
        },
      ],
    };
  },
  computed: {
    bread() {
      let matched = this.$route.matched
        .filter((item) => item.name)
        .filter((item) => item.meta.title);
      return matched;
    },
  },
  watch: {
    $route(nval, oval) {
      if (localStorage.USER_AUTH == "false") {
        let list = this.$store.state.menuList;
        this.menuList = list.find((x) => x.frontendCode == "consumer").child;
      }
      this.getActiveMenu();
    },
  },
  created() {
    if (localStorage.USER_AUTH == "false") {
      let list = this.$store.state.menuList;
      this.menuList = list.find((x) => x.frontendCode == "consumer").child;
    }
    this.getActiveMenu();
  },
  mounted() {},
  methods: {
    getActiveMenu() {
      let path = this.$route.path;
      if (this.menuList.length == 1) {
        this.activeMenu = 1;
      } else {
        this.activeMenu = this.pathList.indexOf(path) > -1 ? 2 : 1;
      }
    },
    linkPath(path) {
      if (path == "/serveUse/serveUseAppList") {
        this.$router.push({
          path: path,
          query: {
            id: localStorage.getItem("adminAppId"),
          },
        });
      } else {
        this.$router.push({ path: path });
      }
    },
    link(path, num) {
      this.activeMenu = num;
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss">
.appindex {
  width: 100%;
  height: 100%;
  &-left {
    width: 190px;
    height: 100%;
    background: #ffffff;
    > .line {
      width: 142px;
      height: 1px;
      background: #ebedf0;
      margin: 24px auto 16px;
    }
    &-menu {
      width: 100%;
      height: 38px;
      padding-left: 24px;
      display: flex;
      align-items: center;
      color: #67799c;
    }
    .menuactive {
      color: #3c8aff;
      background: rgba(60, 138, 255, 0.05);
    }
  }
  &-right {
    width: calc(100% - 190px);
    height: 100%;
    padding: 0px 24px;
    .linkspan:hover {
      color: #3c8aff;
    }
    &-top {
      display: flex;
      .bread {
        color: #2f4061;
        margin: 24px 0;
      }
      .serveUrl {
        display: flex;
        margin: 24px 0;
        margin-left: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #67799c;
        .url {
          margin-left: 5px;
        }
        .editImg {
          color: #3c8aff;
          margin-left: 10px;
        }
      }
    }

    &-main {
      height: calc(100% - 78px);
      overflow: auto;
    }
  }
}
</style>
